import React, { forwardRef } from 'react';
import Checkbox from 'components/common/input-components/checkbox';
import type { CheckboxProps, CheckboxRef } from 'antd';

const BigCheckbox = forwardRef<CheckboxRef, CheckboxProps>((props, ref) => <Checkbox ref={ref} {...props} big />);

BigCheckbox.displayName = 'BigCheckbox';

export default BigCheckbox;
